import { User } from '../../shared/models/User';
import { Catalog } from './Catalog.model';
import { HrSkill } from '../../shared/models/hr-skills-referential/skill.model';

export class Course {
    public catalog: string | Catalog;
    public goal: string;
    public id: string;
    public name: string;
    public owner: User;
    public skills: HrSkill[];

    constructor(json?) {
        if (json) {
            this.id = json.id;
            this.name = json.name;
            this.goal = json.goal;
            this.owner = json.owner;
            this.skills = json.skills;
            this.catalog = json.catalog;
        }
    }
}
